import request from '../../utils/request';
import { getStartTime, getEndTime } from '../../utils/timer';

export async function getPayEntryRatioOptionsRequest() {
  return request({
    url: `payEntryData/summary/ratioOptions`,
    headers: 'json',
    method: 'get',
  });
}

export async function fetchPayEntryDataRequest(params) {
  const { startTime, endTime, ...rest } = params;
  let q = {};
  if (startTime && endTime) {
    q.startTime = getStartTime(startTime);
    q.endTime = getEndTime(endTime);
  }
  return request({
    url: `payEntryData/summary/list`,
    headers: 'json',
    method: 'post',
    params: { ...q, ...rest },
  });
}

export async function updatePayEntryStatusRequest(params) {
  return request({
    url: `payEntryData/summary/updateStatus`,
    headers: 'json',
    method: 'post',
    params,
  });
}

export async function importPayEntryDataRequest(params) {
  return request({
    url: `payEntryData/summary/importData`,
    headers: 'json',
    method: 'post',
    params,
  });
}

export async function getImportProgressRequest(params) {
  return request({
    url: `payEntryData/summary/getImportProgress`,
    headers: 'json',
    method: 'get',
    params,
  });
}

export async function exportPayEntryDataRequest(params) {
  const { startTime, endTime, ...rest } = params;
  let q = {};
  if (startTime && endTime) {
    q.startTime = getStartTime(startTime);
    q.endTime = getEndTime(endTime);
  }
  return request({
    url: `payEntryData/summary/exportData`,
    headers: 'json',
    method: 'post',
    params: { ...q, ...rest },
    responseType: 'blob',
  });
}

export async function removePayEntryDataRequest(params) {
  return request({
    url: `payEntryData/summary/remove`,
    headers: 'json',
    method: 'post',
    params,
  });
}

export async function updateBuyerInfoRequest(params) {
  return request({
    url: `payEntryData/summary/updateBuyerInfo`,
    headers: 'json',
    method: 'post',
    params,
  });
}

export async function updateRepaymentAmountRequest(params) {
  return request({
    url: `payEntryData/summary/updateRepaymentAmount`,
    headers: 'json',
    method: 'post',
    params,
  });
}

export async function fetchPayEntryDataDetailRequest(params) {
  const { repaymentStartTime, repaymentEndTime, ...rest } = params;
  let q = {};
  if (repaymentStartTime && repaymentEndTime) {
    q.repaymentStartTime = getStartTime(repaymentStartTime);
    q.repaymentEndTime = getEndTime(repaymentEndTime);
  }
  return request({
    url: `payEntryData/summary/detailList`,
    headers: 'json',
    method: 'post',
    params: { ...q, ...rest },
  });
}

export async function getMasterCustomListRequest(params) {
  return request({
    url: `custom/getMasterCustomList`,
    headers: 'json',
    method: 'get',
    params,
  });
}

export async function addPayEntryDataRequest(params) {
  return request({
    url: `payEntryData/summary/addData`,
    headers: 'json',
    method: 'post',
    params,
  });
}
